import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-navigation-logged-out-home-section-services',
  template: `
    <app-navigation-logged-out-home-list
      [list]="servicesList"
      [marginBottomTablet]="'xxsmall'"
    >
    </app-navigation-logged-out-home-list>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationLoggedOutHomeSectionServicesComponent {
  servicesList = [
    {
      linkDescription: $localize`Preferred Freelancer Program`,
      linkUrl: '/preferred-freelancer-program',
    },
    {
      linkDescription: $localize`Verified by Freelancer`,
      linkUrl: '/verified',
    },
    {
      linkDescription: $localize`Project management`,
      linkUrl: '/project-management',
    },
    {
      linkDescription: $localize`Recruiter`,
      linkUrl: '/recruiter',
    },
    {
      linkDescription: $localize`Memberships`,
      linkUrl: '/membership',
    },
  ];
}
